module.exports = __webpack_public_path__ + "img/DE00317.1b7630ba.png";